// removed by extract-text-webpack-plugin
module.exports = {"description":"_3QQcnjr5nPeE21YI_gFo0o","icon":"_3D9rHU8_k4QC9IOiOyx_b9","additionalInfo":"_23EXqtBSzmiFCl3GTroamb","contactRow":"_2R2Irzw8dxQJ-XEOXfvGgC","phone":"FXtD593hzCs9KT4Hj3tsw"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CompanyInPropertiesList/AdditionalInformation/AdditionalInformation.scss
// module id = 1560
// module chunks = 0